const Barra = ((props) => {

  const aceptar = (e) => {
    props.setEvento(e)
    props.setEventoData(props.eventos.filter(a => a.id === e)[0])
  }

    return (<>
    <div className="flex flex-col">
      <div className="flex flex-row justify-between items-center w-full bg-gray-800 text-white pr-5">
       <div className="justify-between">
         <label className="font-semibold text-2xl pr-5">Evento:</label>
         {props.quien.rol===2 ?
         <select 
          className="outline-0 text-lg text-black" 
          value={props.evento}
          onChange={e => aceptar(parseInt(e.target.value))}
        >
          {props.eventos.map((a) => {
                return <option key={a.id} value={a.id}>{a.nombre}</option>
            })
         }
         </select>
         : 
         <label className="text-lg">{props.evento.nombre}</label>
        }
       </div>
       
       {props.quien.rol===2 ?
       <button 
        className="text-lg my-2 text-lg px-2 text-blue-800 bg-blue-200 hover:text-blue-200 hover:bg-blue-800"
        onClick={() => {if(props.quien.rol===2) props.setCual(true) }}
        >Eventos
        </button>
        : '' }
       <div className="justify-between text-2xl">
         <label className="font-semibold pr-5">Usuario:</label><label>{' ' + props.quien.apellido + ' ' + props.quien.nombre}</label>
       </div>
     </div>
     </div>
     </>)
})

export default Barra